<div class="bk-field" [class.is-invalid]="!!errorMessage">
  @if (label) {
    <label
      [id]="labelId"
      [class]="merge('bk-field__label', labelClass)"
      (click)="focusControl()"
      >{{ label }}</label
    >
  }

  <!-- The frame draws fill, border, hover, focus and error for whatever is projected. -->
  <div class="bk-field__control">
    <div class="bk-field__slot" #controlEl>
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Polite, not an alert: a submit that shows several errors at once queues
       them instead of each one cutting off the last. The region stays in the
       DOM so screen readers notice when an error is added to it. The control
       also points at the message through aria-describedby. -->
  <div aria-live="polite">
    @if (errorMessage) {
      <p class="bk-field__error" [id]="messageId">
        <span class="bk-sym" aria-hidden="true">error</span>
        <span>{{ errorMessage }}</span>
      </p>
    }
  </div>
  @if (!errorMessage && hint) {
    <p class="bk-field__hint" [id]="messageId">{{ hint }}</p>
  }
</div>
